export const CONTRIBUTOR_SHALLOW_FRAGMENT = `
  fragment ContributorShallowFragment on Contributor {
    __typename
    id
    name
  }
`;
//# sourceMappingURL=contributor.js.map